module.exports = __webpack_public_path__ + "img/code2@2x.49cbc132.png";